import { doPost, doGet, doDelete } from "../base";

const SCHEDULES_URL = "/user_auth/schedules";

const SET_DAFAULTS = ({ limit, offset, sort }) => {
    let params = [];
    if (limit && limit !== null) {
        params.push("limit=" + limit);
    }
    if (offset && offset !== null) {
        params.push("offset=" + offset);
    }
    if (sort && sort !== null) {
        params.push("sort=" + sort);
    }

    return params;
}

export const postChange = async (scheduleId) => {

    var url = SCHEDULES_URL;

    if (!scheduleId || scheduleId === null) {
        throw new Error("scheduleId cannot be null.");
    }
    url += "/change";

    return await doPost({scheduleId} ,url).catch((error) => {
        throw error;
    });
};

export const getChanges = async (scheduleId) => {

    var url = SCHEDULES_URL;

    if (!scheduleId || scheduleId === null) {
        throw new Error("scheduleId cannot be null.");
    }
    url += "/changes?scheduleId=" + scheduleId;

    return await doGet(url).catch((error) => {
        throw error;
    });
};

export const fetchKarieUserSchedules = async (patientId, pharmacyId, limit = 5, offset = 0, sort) => {

    var url = SCHEDULES_URL;

    if (!patientId || patientId === null) {
        throw new Error("patientId cannot be null.");
    }
    if (!pharmacyId || pharmacyId === null) {
        throw new Error("pharmacyId cannot be null.");
    }
    let params = SET_DAFAULTS({limit, offset, sort});
    params.push("patientId=" + patientId);
    params.push("pharmacyId=" + pharmacyId);
    
    for (let i=0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const fetchPharmacySchedules = async ({clientId, startDate, endDate, pouchBarcode}) => {
    if (!clientId) {
        throw new Error("clientId cannot be null.");
    }

    let url = SCHEDULES_URL + "/pharmacy?clientId=" + clientId;
    if (pouchBarcode) {
        url += "&pouchBarcode=" + pouchBarcode;
    } else {
        if (!startDate || !endDate) {
            throw new Error("date cannot be null.");
        }
        url += "&startDate=" + startDate + "&endDate=" + endDate;
    }
    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const fetchScheduleDetails = async (scheduleId) => {
    var url = SCHEDULES_URL;

    if(!scheduleId) {
        throw new Error("scheduleId cannot be null.")
    }

    url += "/" + scheduleId;

    return await doGet(url).catch((error) => {
        throw error;
    });
};

export const deleteScheduleById = async (scheduleId) => {
    var url = SCHEDULES_URL;

    if (!scheduleId) {
        throw new Error("scheduleId cannot be null.")
    }

    url += "/" + scheduleId;

    return await doDelete(url).catch((error) => {
        throw error;
    });
};
